const isValidResponse = { isValid: true }

const ERROR_CODES = Object.freeze({
  EMPTY_MOBILE_NUMBER: "EMPTY_MOBILE_NUMBER",
  INVALID_MOBILE_NUMBER_FORMAT: "INVALID_MOBILE_NUMBER_FORMAT",
  EMPTY_EMAIL: "EMPTY_EMAIL",
  INVALID_EMAIL_FORMAT: "INVALID_EMAIL_FORMAT",
  SPAM_EMAIL: "SPAM_EMAIL",
  EMPTY_PASSWORD: "EMPTY_PASSWORD",
  VERIFY_PASSWORD_DO_NOT_MATCH: "VERIFY_PASSWORD_DO_NOT_MATCH",
  PASSWORD_NOT_ALPHANUMERIC: "PASSWORD_NOT_ALPHANUMERIC",
  PASSWORD_LENGTH_LESS_THAN_8: "PASSWORD_LENGTH_LESS_THAN_8",
  EMPTY_FIRST_NAME: "EMPTY_FIRST_NAME",
  EMPTY_LAST_NAME: "EMPTY_LAST_NAME",
})

const isValueEmpty = (val = "") => {
  if (!val) {
    return true
  }

  if (typeof val === "string") {
    return !val.trim()
  }

  return false
}

const mobileNumberValidator = (mobileNumber = "") => {
  if (isValueEmpty(mobileNumber)) {
    return { isValid: false, error: ERROR_CODES.EMPTY_MOBILE_NUMBER }
  }

  const isValidFormat = /^0([7-9][0-9]{9})$/i.test(mobileNumber)

  if (!isValidFormat) {
    return { isValid: false, error: ERROR_CODES.INVALID_MOBILE_NUMBER_FORMAT }
  }

  return isValidResponse
}

const emailValidator = (email = "") => {
  if (isValueEmpty(email)) {
    return { isValid: false, error: ERROR_CODES.EMPTY_EMAIL }
  }

  const isValidFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)

  if (!isValidFormat) {
    return { isValid: false, error: ERROR_CODES.INVALID_EMAIL_FORMAT }
  }

  const isSpam = isSpamEmail(email)

  if (isSpam) {
    return { isValid: false, error: ERROR_CODES.SPAM_EMAIL }
  }

  return isValidResponse
}

const isSpamEmail = email => {
  return /^\d*@qq.com$/.test(email)
}

const customerPasswordValidator = (pw = "") => {
  if (isValueEmpty(pw)) {
    return { isValid: false, error: ERROR_CODES.EMPTY_PASSWORD }
  }

  //orig
  // const alphaNumericPattern = /^[\w\~\!\@\#\$\%\^\&\*\_\-\+\=\`\|\\\(\)\{\}\[\]\:\;\"\'\<\>\,\.\?\/]+$/i
  const alphaNumericPattern = /^[\w~!@#$%^&*_\-+=`|\\(){}[\]:;"'<>,.?/]+$/i

  if (!alphaNumericPattern.test(pw)) {
    return { isValid: false, error: ERROR_CODES.PASSWORD_NOT_ALPHANUMERIC }
  }

  if (pw.length < 8) {
    return {
      isValid: false,
      error: ERROR_CODES.PASSWORD_LENGTH_LESS_THAN_8,
    }
  }

  return isValidResponse
}

const customerVerifyPasswordValidator = (
  password = "",
  verifyPassword = ""
) => {
  if (!password || !verifyPassword) {
    return {
      isValid: false,
      error: ERROR_CODES.EMPTY_PASSWORD,
    }
  }

  if (password !== verifyPassword) {
    return {
      isValid: false,
      error: ERROR_CODES.VERIFY_PASSWORD_DO_NOT_MATCH,
    }
  }

  return {
    isValid: true,
  }
}

const firstNameValidator = (firstName = "") => {
  if (isValueEmpty(firstName)) {
    return { isValid: false, error: ERROR_CODES.EMPTY_FIRST_NAME }
  }

  return isValidResponse
}
const lastNameValidator = (lastName = "") => {
  if (isValueEmpty(lastName)) {
    return { isValid: false, error: ERROR_CODES.EMPTY_LAST_NAME }
  }

  return isValidResponse
}

export {
  emailValidator,
  mobileNumberValidator,
  customerPasswordValidator,
  customerVerifyPasswordValidator,
  firstNameValidator,
  lastNameValidator,
  isValueEmpty,
  isValidResponse,
  ERROR_CODES,
}
